import './LimitsValidation.scss';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TranslationKey, useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ILimitInfo, ITakeOverWorkspaceLimits } from '../workspaces.store';

export const LimitsValidation = observer((props: ITakeOverWorkspaceLimits): ReactElement => {
  const { t } = useTranslator();
  const limitIsExceeded = (limit: ILimitInfo): boolean => limit.targetLimit !== -1 && limit.targetLimitUsage + limit.workspaceLimitUsage > limit.targetLimit;

  const getExceededLimits = (): string => {
    const surpassedLimits: TranslationKey[] = [];

    if (limitIsExceeded(props.storage)) {
      surpassedLimits.push('limit_storage_space');
    }
    if (limitIsExceeded(props.users)) {
      surpassedLimits.push('limit_unique_users');
    }
    if (limitIsExceeded(props.workspaces)) {
      surpassedLimits.push('limit_workspaces');
    }
    if (!props.canEncrypt) {
      surpassedLimits.push('limit_encryption');
    }

    return `${surpassedLimits.map((limit) => t(limit)).join(', ')}.`;
  };

  return (
    <>
      {props.isAllowed && (
        <div className='change-owner-allowed'>
          <FontAwesomeIcon icon={faInfoCircle} /> {t('change_workspace_owner_allowed')}
        </div>
      )}
      {!props.isAllowed && (
        <div className='change-owner-denied'>
          <FontAwesomeIcon icon={faInfoCircle} /> {t('change_workspace_owner_denied')}
          {getExceededLimits()}
        </div>
      )}
    </>
  );
});
